import { getTamarikiList } from "../config/tamariki";
import { getMarae } from "../config/marae";
import { getHapu } from "../config/hapu";

export const createSurveyConfig = async () => {
    const tamarikiList = getTamarikiList();
    const marae = await getMarae();
    const hapuData = await getHapu();

    const surveyJSON = {
        pages: [
            {
                name: "personalDetails",
                title: "Personal Details",
                questions: [
                    {
                        type: "dropdown",
                        name: "title",
                        title: "Title",
                        colCount: 0,
                        choices: ["Mrs", "Mr", "Miss"],
                    },
                    {
                        type: "text",
                        name: "surname",
                        title: "Surname",
                        placeHolder: "Ingoa Whānau",
                        isRequired: true,
                    },
                    {
                        type: "text",
                        name: "firstName",
                        title: "First Name(s)",
                        placeHolder: "Ingoa",
                        isRequired: true,
                    },
                    {
                        type: "text",
                        name: "maidenName",
                        title: "Maiden Name",
                        placeHolder: "Where applicable",
                    },
                    {
                        type: "text",
                        name: "aka",
                        title: "Also known as",
                        placeHolder: "Ingoa kē",
                    },
                    {
                        type: "mybootstrapdatepicker",
                        inputType: "date",
                        name: "dob",
                        title: "Date of Birth",
                        isRequired: true,
                    },
                    {
                        type: "dropdown",
                        name: "gender",
                        title: "Gender",
                        choices: ["Female", "Male"],
                        isRequired: true,
                    },
                    {
                        type: "text",
                        name: "spouse",
                        title: "Spouse/Partner's Full Name",
                        placeHolder: "Hoa Rangatira",
                    },
                ],
            },
            {
                name: "address",
                title: "Address",
                questions: [
                    {
                        title: "Address",
                        type: "addressfinder",
                        name: "address",
                        isRequired: true,
                    },
                ],
            },
            {
                name: "contactDetails",
                title: "Contact Details",
                questions: [
                    {
                        title: "Phone",
                        type: "text",
                        name: "phone",
                    },
                    {
                        title: "Cell",
                        type: "text",
                        name: "cell",
                    },
                    {
                        title: "Email",
                        type: "text",
                        name: "email",
                        validators: [
                            {
                                type: "email",
                            },
                        ],
                    },
                    {
                        title: "How should we contact you?",
                        type: "dropdown",
                        name: "preferredContact",
                        choices: ["Post", "Email", "Text/SMS"],
                    },
                    {
                        title: "How did you find out about us?",
                        type: "text",
                        name: "referrer",
                    },
                ],
            },
            {
                name: "tamariki",
                title: "Tamariki",
                questions: tamarikiList,
            },
            {
                name: "connectionMaraePrimary",
                title: "Connection to Ngāti Rangi - Marae",
                questions: [
                    {
                        type: "maraePicker",
                        name: "marae",
                        title: "Please Select Your Primary Marae",
                        isRequired: true,
                    },
                ],
            },
            {
                name: `maraeKuratahi`,
                title: "Hapū",
                questions: [
                    {
                        type: "dropdown",
                        name: "hapuKuratahi",
                        title: "Please choose your hapū from Kuratahi",
                        visibleIf: `maraeVisible({marae}, "${marae.Kuratahi.description}")`,
                        isRequired: true,
                        choices: [
                            hapuData.Rangituhia.description,
                            hapuData.Parenga.description,
                        ],
                    },
                ],
            },
            {
                name: "maraeTeAoHou",
                title: "Hapū",
                questions: [
                    {
                        type: "dropdown",
                        name: "hapuTeAoHou",
                        title: "Please choose your hapū from Te Ao Hou",
                        visibleIf: `maraeVisible({marae}, "${marae["Te Ao Hou"].description}")`,
                        isRequired: true,
                        choices: [
                            hapuData.Tupoho.description,
                            hapuData["Rangi-ki-tai"].description,
                        ],
                    },
                ],
            },
            {
                name: "maraeTirorangi",
                title: "Hapū",
                questions: [
                    {
                        type: "dropdown",
                        name: "hapuTirorangi",
                        title: "Please choose your hapū from Tirorangi",
                        visibleIf: `maraeVisible({marae}, "${marae.Tirorangi.description}")`,
                        isRequired: true,
                        choices: [
                            hapuData.Tongaiti.description,
                            hapuData.Rangiteauria.description,
                        ],
                    },
                ],
            },
            {
                name: "maraeMangamingi",
                title: "Hapū",
                questions: [
                    {
                        type: "dropdown",
                        name: "hapuMangamingi",
                        title: "Please choose your hapū from Mangamingi",
                        visibleIf: `maraeVisible({marae}, "${marae.Mangamingi.description}")`,
                        isRequired: true,
                        choices: [
                            hapuData.Tamakana.description,
                            hapuData.Uenuku.description,
                        ],
                    },
                ],
            },
            {
                name: "maraeRaetihi",
                title: "Hapū",
                questions: [
                    {
                        type: "dropdown",
                        name: "hapuRaetihiTePuke",
                        title: "Please choose your hapū from Raetihi (Te Puke)",
                        visibleIf: `maraeVisible({marae}, "${marae.Raetihi.description}")`,
                        isRequired: true,
                        choices: [
                            hapuData.Uenukumanawawiri.description,
                            hapuData.Uenuku.description,
                        ],
                    },
                ],
            },
            {
                name: "maraeMoteKatoa",
                title: "Hapū",
                questions: [
                    {
                        type: "dropdown",
                        name: "hapuMoteKatoa",
                        title: "Please choose your hapū from Mote Katoa",
                        visibleIf: `maraeVisible({marae}, "${marae.Motekatoa.description}")`,
                        isRequired: true,
                        choices: [
                            hapuData.Uenuku.description,
                            hapuData.Patutokotoko.description,
                        ],
                    },
                ],
            },
            {
                name: "maraeWaitahuparae",
                title: "Hapū",
                questions: [
                    {
                        type: "dropdown",
                        name: "hapuWaitahuparae",
                        title: "Please choose your hapū from Waitahuparae",
                        visibleIf: `maraeVisible({marae}, "${marae.Waitahuparae.description}")`,
                        isRequired: true,
                        choices: [
                            hapuData.Uenukumanawawiri.description,
                            hapuData.Patutokotoko.description,
                        ],
                    },
                ],
            },
            {
                name: "connectionLandBlack",
                title: "Connection to Ngāti Rangi - Land Block",
                questions: [
                    {
                        type: "text",
                        name: "landBlock",
                        title:
                            "Please identify at least one land block in our rohe that you connect to. Please include the full land block names (and numbers if relevant). E.g. Murimotu 3B2B3",
                        visibleIf: '{marae} == "aua"',
                        isRequired: true,
                    },
                ],
            },
            {
                name: "connectionMaraeSecondary",
                title: "Connection to Ngāti Rangi - Marae",
                questions: [
                    {
                        type: "maraePicker",
                        name: "secondaryMarae",
                        title: "Please Select Your Secondary Marae",
                        visibleIf: '{marae} != "aua"',
                        isRequired: true,
                    },
                ],
            },
            {
                name: "secondaryMaraeKuratahi",
                title: "Hapū",
                questions: [
                    {
                        type: "dropdown",
                        name: "secondaryHapuKuratahi",
                        title: "Please choose your hapū from Kuratahi",
                        visibleIf: `maraeVisible({secondaryMarae}, "${marae.Kuratahi.description}")`,
                        isRequired: true,
                        choices: [
                            hapuData.Rangituhia.description,
                            hapuData.Parenga.description,
                        ],
                    },
                ],
            },
            {
                name: "maraeTeAoHou",
                title: "Hapū",
                questions: [
                    {
                        type: "dropdown",
                        name: "secondaryHapuTeAoHou",
                        title: "Please choose your hapū from Te Ao Hou",
                        visibleIf: `maraeVisible({secondaryMarae}, "${marae["Te Ao Hou"].description}")`,
                        isRequired: true,
                        choices: [
                            hapuData.Tupoho.description,
                            hapuData["Rangi-ki-tai"].description,
                        ],
                    },
                ],
            },
            {
                name: "maraeTirorangi",
                title: "Hapū",
                questions: [
                    {
                        type: "dropdown",
                        name: "secondaryHapuTirorangi",
                        title: "Please choose your hapū from Tirorangi",
                        visibleIf: `maraeVisible({secondaryMarae}, "${marae.Tirorangi.description}")`,
                        isRequired: true,
                        choices: [
                            hapuData.Tongaiti.description,
                            hapuData.Rangiteauria.description,
                        ],
                    },
                ],
            },
            {
                name: "maraeMangamingi",
                title: "Hapū",
                questions: [
                    {
                        type: "dropdown",
                        name: "secondaryHapuMangamingi",
                        title: "Please choose your hapū from Mangamingi",
                        visibleIf: `maraeVisible({secondaryMarae}, "${marae.Mangamingi.description}")`,
                        isRequired: true,
                        choices: [
                            hapuData.Tamakana.description,
                            hapuData.Uenuku.description,
                        ],
                    },
                ],
            },
            {
                name: "maraeRaetihi",
                title: "Hapū",
                questions: [
                    {
                        type: "dropdown",
                        name: "secondaryHapuRaetihiTePuke",
                        title: "Please choose your hapū from Raetihi (Te Puke)",
                        visibleIf: `maraeVisible({secondaryMarae}, "${marae.Raetihi.description}")`,
                        isRequired: true,
                        choices: [
                            hapuData.Uenukumanawawiri.description,
                            hapuData.Uenuku.description,
                        ],
                    },
                ],
            },
            {
                name: "maraeMoteKatoa",
                title: "Hapū",
                questions: [
                    {
                        type: "dropdown",
                        name: "secondaryHapuMoteKatoa",
                        title: "Please choose your hapū from Mote Katoa",
                        visibleIf: `maraeVisible({secondaryMarae}, "${marae.Motekatoa.description}")`,
                        isRequired: true,
                        choices: [
                            hapuData.Uenuku.description,
                            hapuData.Patutokotoko.description,
                        ],
                    },
                ],
            },
            {
                name: "maraeWaitahuparae",
                title: "Hapū",
                questions: [
                    {
                        type: "dropdown",
                        name: "secondaryHapuWaitahuparae",
                        title: "Please choose your hapū from Waitahuparae",
                        visibleIf: `maraeVisible({secondaryMarae}, "${marae.Waitahuparae.description}")`,
                        isRequired: true,
                        choices: [
                            hapuData.Uenukumanawawiri.description,
                            hapuData.Patutokotoko.description,
                        ],
                    },
                ],
            },
            {
                name: "occupation",
                title: "Occupation and Qualifications",
                questions: [
                    {
                        type: "text",
                        name: "occupation",
                        title: "Occupation",
                    },
                    {
                        type: "text",
                        name: "industry",
                        title: "Industry",
                    },
                    {
                        type: "text",
                        name: "qualifications",
                        title: "Qualifications & Skills",
                    },
                ],
            },
            {
                name: "teReo",
                title: "Te Reo Māori",
                questions: [
                    {
                        type: "radiogroup",
                        name: "tereo",
                        title: "Proficiency",
                        choices: ["Native Speaker", "Fluent", "Basic", "None"],
                        isRequired: true,
                    },
                ],
            },
            {
                name: "whakapapa",
                title: "Whakapapa to Ngāti Rangi",
                questions: [
                    {
                        type: "html",
                        html:
                            "Please complete your whakapapa to the best of your ability to assist us to confirm your registation as an uri or Ngāti Rangi. Please only include your Ngāti Rangi line.",
                    },
                    {
                        type: "text",
                        name: "whakapapa_w",
                        title: "Whaea - Mother",
                    },
                    {
                        type: "text",
                        name: "whakapapa_m",
                        title: "Matua - Father",
                    },
                    {
                        type: "text",
                        name: "whakapapa_ww",
                        visibleIf: "whakapapaVisible({whakapapa_w})",
                        title: "Kuia Whaea - Mother's Mother",
                    },
                    {
                        type: "text",
                        name: "whakapapa_wm",
                        visibleIf: "whakapapaVisible({whakapapa_w})",
                        title: "Tupuna Whaea - Mother's Father",
                    },
                    {
                        type: "text",
                        name: "whakapapa_mw",
                        visibleIf: "whakapapaVisible({whakapapa_m})",
                        title: "Kuia - Father's Mother",
                    },
                    {
                        type: "text",
                        name: "whakapapa_mm",
                        visibleIf: "whakapapaVisible({whakapapa_m})",
                        title: "Tupuna - Father's Father",
                    },
                    {
                        type: "text",
                        name: "whakapapa_www",
                        visibleIf: "whakapapaVisible({whakapapa_ww})",
                        title: "Tupuna Kuia - Mother's Mother's Mother",
                    },
                    {
                        type: "text",
                        name: "whakapapa_wwm",
                        visibleIf: "whakapapaVisible({whakapapa_ww})",
                        title: "Matua Tupuna - Mother's Mother's Father",
                    },
                    {
                        type: "text",
                        name: "whakapapa_wmw",
                        visibleIf: "whakapapaVisible({whakapapa_wm})",
                        title: "Tupuna Kuia - Mother's Father's Mother",
                    },
                    {
                        type: "text",
                        name: "whakapapa_wmm",
                        visibleIf: "whakapapaVisible({whakapapa_wm})",
                        title: "Tupuna Matua - Mother's Father's Father",
                    },
                    {
                        type: "text",
                        name: "whakapapa_mww",
                        visibleIf: "whakapapaVisible({whakapapa_mw})",
                        title: "Tupuna Kuia - Father's Mother's Mother",
                    },
                    {
                        type: "text",
                        name: "whakapapa_mwm",
                        visibleIf: "whakapapaVisible({whakapapa_mw})",
                        title: "Matua Tupuna - Father's Mother's Father",
                    },
                    {
                        type: "text",
                        name: "whakapapa_mmw",
                        visibleIf: "whakapapaVisible({whakapapa_mm})",
                        title: "Tupuna Kuia - Father's Father's Mother",
                    },
                    {
                        type: "text",
                        name: "whakapapa_mmm",
                        visibleIf: "whakapapaVisible({whakapapa_mm})",
                        title: "Tupuna Matua - Father's Father's Father",
                    },
                ],
            },
            {
                name: "privacy",
                title: "Declaration & Privacy",
                questions: [
                    {
                        type: "html",
                        html: `We collect personal information from you, including information such as your name, contact information and other information as set out in
      this form.<br/><br/>
      Any personal information you provide to us is subject to the Privacy Act 1993.<br/><br/>
      We collect your personal information in connection with the Trust’s purposes, including to keep you informed about the activities of the Ngāti Rangi Trust, maintain our iwi register,
      ensure we have up to date information about our beneficiaries, and to ensure you are able to vote on important Ngāti Rangi issues.<br/><br/>
      We will not disclose your personal information to third parties without your permission.<br/><br/>
      You have the right to ask for a copy of any personal information we hold about you, and to ask for it to be corrected if you think it is wrong.<br/><br/>
      If you would like to ask for a copy of your information, or to have it corrected, please contact us at office@ngatirangi.com, or 0800 N RANGI, or PO Box 195, Ohakune.`,
                    },
                    {
                        name:
                            "I understand that the information I provide is subject to the Privacy Act 1993",
                        type: "checkbox",
                        choices: ["Āe"],
                        isRequired: true,
                    },
                    {
                        name:
                            "I agree to my information being passed on to my respective marae indicated above",
                        type: "checkbox",
                        choices: ["Āe"],
                        isRequired: true,
                    },
                    {
                        name:
                            "I confirm that the information provided in this form is true and correct",
                        type: "checkbox",
                        choices: ["Āe"],
                        isRequired: true,
                    },
                    {
                        name: "signed",
                        type: "signaturepad",
                        title: "Please use your mouse to sign your name",
                        isRequired: true,
                    },
                ],
            },
        ],
    };

    console.log(surveyJSON);

    return surveyJSON;
};
